export const HttpStatus = {
    ClientError: 400,
    Forbidden: 403,
    NotFound: 404,
    ServerError: 500,
} as const;
export type HttpStatus = typeof HttpStatus[keyof typeof HttpStatus];
